const swiperPartenaires = new Swiper("#partenaires-swiper", {
  slidesPerView: 2,
  spaceBetween: 0,

  navigation: {
    nextEl: "#partenaires-next",
    prevEl: "#partenaires-prev",
  },

  autoplay: {
    delay: 4000,
  },

  breakpoints: {
    375: {
      slidesPerView: 3,
      spaceBetween: 10,
    },
    640: {
      slidesPerView: 4,
      spaceBetween: 10,
    },
    768: {
      slidesPerView: 5,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 7,
      spaceBetween: 10,
    },
  },
});
